import { Enums } from '../common/enums'

export class OperatorLayoutSetting {
    private type: Enums.SimaxOperatorLayoutSetting
    private postfix: string

    constructor(type: Enums.SimaxOperatorLayoutSetting, postfix: string = "") {
        this.type = type
        this.postfix = postfix
    }

    public getName() {
        if (this.postfix != "")
            return Enums.SimaxOperatorLayoutSetting[this.type] + '_' + this.postfix
        else
            return Enums.SimaxOperatorLayoutSetting[this.type]
    }
}